export interface LoyaltyReport {
  id: number
  code: string
  description: string
  query_condition: LoyaltyReportQueryCondition
  query_count: any
  report_state: string
  error: string
  flg_state: string
  flg_kf: string
  flg_dpl: string
  user_ins_id: number
  ts_ins: string
  user_upd_id: number
  ts_upd: string
  user_del_id: any
  ts_del: any
}

interface LoyaltyReportQueryCondition {
  condition: string
  rules: LoyaltyReportRule[]
}

interface LoyaltyReportRule {
  condition?: string
  rules?: LoyaltyReportRule2[]
  field?: string
  value: any
  operator?: string
}

interface LoyaltyReportRule2 {
  dateValue: string
  field: string
  value: string
  operator: string
}

export interface LoyaltyReportData {
  code: string
  description: string
  storeTotal: boolean
  chainTotal: boolean
  acm: number
  storeGroup: number[]
  storeChain: number[]
  store: number
  startDate: string
  endDate: string
  startDateValue: string
  endDateValue: string
}

export class LoyaltyReportPayload {
  condition: "and";
  rules: LoyaltyReportPayloadRule[];

  constructor(data: LoyaltyReportData) {
    this.condition = 'and';
    this.rules = [
      {
        condition: 'and',
        rules: [
          {
            field: 'd.xact_date',
            operator: '>=',
            dateValue: data.startDateValue,
            value: data.startDate
          },
          {
            field: 'd.xact_date',
            operator: '<=',
            dateValue: data.endDateValue,
            value: data.endDate
          }
        ]
      },
      {
        field: 'a.id',
        operator: 'in',
        value: data.storeChain
      },
      {
        field: 'b.id',
        operator: 'in',
        value: data.storeGroup
      },
      {
        field: 'c.id',
        operator: '=',
        value: data.store
      },
      {
        field: 'd.acm_id',
        operator: '=',
        value: data.acm
      }
    ];
  }
}

interface LoyaltyReportPayloadRule {
  condition?: "and";
  rules?: LoyaltyReportPayloadRule[];
  field?: string;
  operator?: string;
  dateValue?: string;
  value?: any;
}



// WEBPACK FOOTER //
// ./src/app/models/loyalty-report.model.ts